import Swal from "sweetalert2";
import { ensureThemeJsonArray } from "./themeAssets";
import {
  parseQuizFromTheme,
  parseRaceAssetsFromTheme,
  parseStringList,
} from "../pages/game/raceGameUtils";

const QUIZ_MIN_QUESTIONS = 1;

function hasText(val) {
  const s = String(val ?? "").trim();
  if (!s) return false;
  const lower = s.toLowerCase();
  return lower !== "null" && lower !== "undefined" && lower !== "none";
}

function collectRaceMissing(themeData, missing, { requireQuiz = true } = {}) {
  const assets = parseRaceAssetsFromTheme(themeData);
  if (!hasText(themeData?.road_image)) {
    missing.push("Stage 1 (Race): upload a road image");
  }
  if (!assets.carUrls.length) {
    missing.push("Stage 1 (Race): upload at least 1 car image (PNG/GIF)");
  }
  if (!assets.obstacleUrls.length) {
    missing.push("Stage 1 (Race): upload at least 1 obstacle image");
  }

  if (requireQuiz) {
    const quiz = parseQuizFromTheme(themeData);
    if (quiz.length < QUIZ_MIN_QUESTIONS) {
      missing.push(
        `Stage 1 (Race): need at least ${QUIZ_MIN_QUESTIONS} quiz question (found ${quiz.length})`
      );
    }
  }
}

/**
 * Validate that themeData has race assets (+ quiz for quiz mode) for Stage 1.
 * @returns {{ ok: boolean, missing: string[] }}
 */
export function validateThemeStageData(themeData, options = {}) {
  if (!themeData || typeof themeData !== "object") {
    return {
      ok: false,
      missing: ["Theme data is missing. Please configure the theme before starting the game."],
    };
  }

  const mode = String(options.mode || "").trim();
  const requireQuiz = mode !== "endless_runner";
  const missing = [];
  collectRaceMissing(themeData, missing, { requireQuiz });

  // Keep array parse available for admin-saved JSON strings.
  ensureThemeJsonArray(themeData?.car_images);
  parseStringList(themeData?.obstacle_images);

  return { ok: missing.length === 0, missing };
}

/** Shared Swal for incomplete theme stage data. */
export function fireThemeStageDataMissingSwal(missing = []) {
  const missingList = (missing || [])
    .map((item) => `<li>${String(item)}</li>`)
    .join("");
  return Swal.fire({
    icon: "warning",
    title: "Required game data missing",
    html: `<p>Add the missing items in <strong>Admin → Theme → Game Content</strong> (Game Image / Quiz), then try again. The game will not start until these are set.</p><ul style="text-align:left;margin:12px 0 0;padding-left:18px;max-height:240px;overflow:auto;">${missingList}</ul>`,
    confirmButtonText: "OK",
    allowOutsideClick: false,
    allowEscapeKey: false,
  });
}
